import { allowOnlyWithCompletedJourney } from '@/router/routerGuards'
import { AppSidebar, AppHeader } from '@/components'
import FooterOutgoingLinks from '@/components/FooterOutgoingLinks.vue'
import router from '@/router'

export const routes = [
  {
    path: '/product',
    name: 'product',
    redirect: { name: 'dashboard' },
    components: {
      default: () => import('./layouts/matchesFormLayout.vue'),
      header: AppHeader
    },
    children: [
      {
        path: 'loan',
        name: 'loan-matches-form',
        redirect: {
          name: 'goals',
          query: {
            type: 'loans'
          }
        }
      },
      {
        path: 'equity',
        name: 'equity-matches-form',
        redirect: {
          name: 'goals',
          query: {
            type: 'equity'
          }
        }
      },
      {
        path: 'grant',
        name: 'grant-matches-form',
        redirect: {
          name: 'goals',
          query: {
            type: 'grant'
          }
        }
      }
    ]
  },
  {
    path: '/matches',
    components: {
      default: () => import('./layouts/matchesLayout.vue'),
      header: AppHeader,
      sidebar: AppSidebar,
      footer: FooterOutgoingLinks
    },
    beforeEnter: allowOnlyWithCompletedJourney(),
    children: [
      {
        path: 'equity',
        name: 'equity-matches',
        component: () => import('./equity/equityMatches.vue'),
        meta: {
          sitemap: {
            title: 'Equity funding',
            description: 'Explore equity investment opportunities',
            conditions: {
              all: [{ fact: 'global', path: '$.hasEquityProducts', operator: 'equal', value: true }]
            }
          },
          permissions: {
            roles: ['user'],
            redirectTo: {
              name: 'login'
            }
          }
        }
      },
      {
        path: 'grants',
        name: 'grant-matches',
        component: () => import('./grant/grantMatches.vue'),
        meta: {
          sitemap: {
            title: 'Grant funding',
            description: 'Browse available grant opportunities',
            conditions: {
              all: [{ fact: 'global', path: '$.hasGrantProducts', operator: 'equal', value: true }]
            }
          },
          permissions: {
            roles: ['user'],
            redirectTo: {
              name: 'login'
            }
          }
        }
      },
      {
        path: 'grants/:slug',
        name: 'grant-detail',
        component: () => import('./grant/grantDetail.vue'),
        meta: {
          sitemap: {
            title: 'Grant details',
            description: 'View grant funding details',
            conditions: {
              all: [{ fact: 'global', path: '$.hasGrantProducts', operator: 'equal', value: true }]
            }
          },
          permissions: {
            roles: ['user'],
            redirectTo: {
              name: 'login'
            }
          }
        }
      },
      {
        path: 'commercial-mortgages',
        name: 'commercial-mortgage-matches',
        component: () => import('./mortgage/mortgageMatches.vue'),
        meta: {
          sitemap: {
            title: 'Commercial mortgages',
            description: 'View commercial mortgage products'
          },
          permissions: {
            roles: ['user'],
            redirectTo: {
              name: 'login'
            }
          }
        }
      }
    ]
  },
  {
    path: '/matches',
    components: {
      default: () => import('./layouts/loanMatchesLayout.vue'),
      header: AppHeader,
      sidebar: AppSidebar,
      footer: FooterOutgoingLinks
    },
    beforeEnter: allowOnlyWithCompletedJourney(),
    children: [
      {
        path: 'loans',
        name: 'loan-matches',
        component: () => import('./loan/loanMatches.vue'),
        meta: {
          documentTitle: 'Funding options',
          sitemap: {
            title: 'Funding options',
            description: "Displays loan product recommendations based on the user's profile.",
            conditions: {
              all: [{ fact: 'global', path: '$.hasLoanProducts', operator: 'equal', value: true }]
            }
          },
          permissions: {
            roles: ['user'],
            redirectTo: {
              name: 'login'
            }
          }
        }
      },
      {
        path: 'loans/get-offers/:fundingReason',
        name: 'get-loan-offers',
        component: () => import('./loan/getOffers.vue'),
        meta: {
          permissions: {
            roles: ['user'],
            redirectTo: {
              name: 'login'
            }
          }
        }
      },
      {
        path: 'loans/submitted',
        name: 'application-submitted',
        component: () => import('./loan/loanAppSubmitted.vue'),
        meta: {
          permissions: {
            roles: ['user'],
            redirectTo: {
              name: 'login'
            }
          }
        }
      }
    ]
  },
  {
    path: '/my-offers',
    name: 'my-offers',
    components: {
      default: () => import('./offers/MyOffersPage.vue'),
      header: AppHeader,
      sidebar: AppSidebar,
      footer: FooterOutgoingLinks
    },
    beforeEnter: allowOnlyWithCompletedJourney(),
    meta: {
      documentTitle: 'Applications',
      sitemap: {
        title: 'Applications',
        description: 'See all active offers and deals'
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    }
  }
]

export default () => {
  routes.forEach(route => router.addRoute(route))
}
